import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HahaHttpService, MachinePairedHahaDevice } from '../../../../core/haha/_services/haha-http.service';
import { coldBrewErrorMessage, coldBrewStatusLabel } from '../../../../core/haha/_utils/cold-brew-labels';
import { MachineRouteService } from '../machine-route.service';

// Read-only: shows the cold brew fridge paired with this machine. Pairing is managed from the fridge.
@Component({
	selector: 'kt-machine-cold-brew',
	templateUrl: './machine-cold-brew.component.html',
	styleUrls: ['./machine-cold-brew.component.scss']
})
export class MachineColdBrewComponent implements OnInit {
	machineName = '';
	result: MachinePairedHahaDevice | null = null;
	isLoading = false;
	errorMessage = '';
	readonly statusLabel = coldBrewStatusLabel;

	constructor(
		private route: ActivatedRoute,
		private machineRouteService: MachineRouteService,
		private hahaHttp: HahaHttpService,
		private cdr: ChangeDetectorRef
	) {}

	ngOnInit(): void {
		const machine = this.machineRouteService.getMachine(this.route);
		if (!machine) {
			return;
		}
		this.machineName = String(machine.machine_name || machine.machine_id || '');
		this.isLoading = true;
		this.hahaHttp.getMachinePairedDevice(String(machine.machine_id || '')).subscribe({
			next: response => {
				this.result = response && response.data ? response.data : null;
				this.isLoading = false;
				this.cdr.detectChanges();
			},
			error: error => {
				this.errorMessage = coldBrewErrorMessage(error, 'Failed to load the paired cold brew fridge.');
				this.isLoading = false;
				this.cdr.detectChanges();
			}
		});
	}

	get fridgeName(): string {
		const device = this.result && this.result.device;
		return device ? device.name || device.haha_market_id : '';
	}
}
